module.exports = __webpack_public_path__ + "static/media/hybriq.caa3e2ca.svg";